import { styled } from '@mui/material'
import { RaRecord, required } from 'ra-core'
import React from 'react'
import { BooleanInput, ArrayInput, SimpleFormIterator } from 'react-admin'
import {
  BriefQuestion,
  GeneralBriefQuestion,
} from 'services/api/entities/servicesconfig'
import { briefQuestionChoices } from 'services/cfg/form'
import {
  ArrayInputContentProps,
  useKArrayInput,
} from 'services/hooks/useKArrayInput'
import KToolTip from 'ui-shared/KTooltip'
import LocalizedAutoCompleteArrayInput from 'ui-shared/LocalizedFields/LocalizedAutoCompleteArrayInput'
import LocalizedInputText from 'ui-shared/LocalizedFields/LocalizedInputText'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'
import BriefServiceInput from './BriefServiceInput'

const PREFIX = 'BriefQuestionInput'

const classes = {
  column: `${PREFIX}-column`,
}

const StyledDiv = styled('div')({
  [`& .${classes.column}`]: {
    display: 'flex',
    flexDirection: 'column',
  },
})

type Props = ArrayInputContentProps & {
  isGeneralQuestion?: boolean
  productChoices?: RaRecord[]
}

const BriefQuestionInput: React.FC<Props> = ({
  source,
  isGeneralQuestion = false,
  productChoices = [],
}) => {
  const { kGetSource, scopedFormData } = useKArrayInput<
    GeneralBriefQuestion | BriefQuestion
  >(source)

  return (
    <StyledDiv className={classes.column}>
      <KToolTip title="form.fields.briefNameTooltip" placement="top-start">
        <LocalizedInputText
          source={kGetSource('text')}
          label="form.fields.question"
        />
      </KToolTip>
      <KSelectInput
        source={kGetSource('type')}
        label="Type"
        choices={briefQuestionChoices}
        defaultValue={briefQuestionChoices[0].id}
        validate={required()}
      />
      <BooleanInput source={kGetSource('mandatory')} label="Is mandatory" />
      {scopedFormData?.type === 'multiple' && (
        <ArrayInput
          source={kGetSource('options')}
          style={{ padding: '16px 0' }}
          label="Options"
        >
          <SimpleFormIterator>
            <LocalizedInputText
              source=""
              label="form.fields.option"
              validate={required()}
            />
          </SimpleFormIterator>
        </ArrayInput>
      )}
      <KToolTip
        title={'form.fields.activeWhenNotServiceTooltip'}
        placement="right-end"
      >
        <BriefServiceInput
          source={kGetSource('notActiveWhenServices')}
          label="form.fields.activeWhenNotService"
        />
      </KToolTip>
      {isGeneralQuestion ? (
        <BriefServiceInput
          source={kGetSource('activeWhenServices')}
          label="form.fields.activeWhenService"
        />
      ) : (
        <KToolTip title="form.fields.activeOnlyFor">
          <LocalizedAutoCompleteArrayInput
            source={kGetSource('products')}
            label="Active only For"
            choices={productChoices}
          />
        </KToolTip>
      )}
    </StyledDiv>
  )
}

export default BriefQuestionInput
